import { axios } from './config';

export function sendEvent(body) {
  return axios.post('/event', body);
};
